import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import useClickOutside from "../../hooks/useClickOutside";
import { adjustPopoverPosition } from "./popoverUtils";

const Popover = ({ anchorPoint, onClose, children }) => {
  const popoverRef = useRef();
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: anchorPoint.y, left: anchorPoint.x });

  useClickOutside(popoverRef, onClose);

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
  }, []);

  // Adjust position to keep within viewport
  useEffect(() => {
    const popoverEl = popoverRef.current;
    const adjustPosition = () => {
      const { top, left } = adjustPopoverPosition(popoverEl, anchorPoint);
      setPosition({ top, left });
    };

    // Run on mount after DOM is ready
    setTimeout(adjustPosition, 0);

    // Recalculate on resize
    window.addEventListener("resize", onClose);
    window.addEventListener("scroll", onClose, true);
    return () => {
      window.removeEventListener("resize", onClose);
      window.removeEventListener("scroll", onClose, true);
    };
  }, [anchorPoint, onClose]);

  const style = {
    top: position.top,
    left: position.left,
    zIndex: 900,
    opacity: visible ? 1 : 0,
    transform: visible ? "scale(1)" : "scale(0.95)",
    transition: "opacity 150ms ease, transform 150ms ease"
  };
  console.log("position", position);

  return ReactDOM.createPortal(
    <div
      ref={popoverRef}
      style={style}
      className={"position_fixed bg_light border_full border_radius_medium shadow_md"}
    >
      {children}
    </div>,
    document.body
  );
};

export default Popover;
